<template>
    <div class="">
        <top></top>
        <div class="container">
            <div class="goods-box F-flex">
                <div class="goods-left flex ali-cen">
                    <img :src="info.item[0].goods_image" alt="" style="" />
                    <div
                        class="goods-info flex flex-column jus-between"
                        style=""
                    >
                        <div>产品名称：{{info.item[0].goods_title }}</div>
                        <div>订单编号：{{info.order_sn }}</div>
                        <div>原始金额: {{info.goods_original_amount }}</div>
                        <div>运费:{{info.dispatch_amount }}</div>
                        <div>优惠:{{info.discount_fee }}</div>
                        <div>购买时间：{{ createTime }}</div>
                        <div>交易号：{{ info.order_sn }}</div>
                    </div>
                </div>
                <div>
                    <span style="color: #FF6701;font-size: 36px;">{{
                        info.total_fee
                    }}</span
                    >元
                </div>
            </div>
            <div class="pay-box">
                <div class="title">
                    <div class="title-line"></div>
                    选择付款方式
                </div>
                <div class="pay-type">
                    <el-radio-group v-model="radio" @change="handlePay">
                        <el-radio label="alipay">支付宝</el-radio>
                        <el-radio label="wechat">微信支付</el-radio>
                        <el-radio :label="9">银联支付</el-radio>
                    </el-radio-group>
                </div>

            </div>
            <div class="onPay">
                <!-- <div class="erweima">支付二维码</div> -->
                <div class="erweima">功能暂未开放~</div>
                <!-- <div class="zhifu">
                    <el-image :src="payImg"></el-image>
                </div> -->
                <!-- <div class="on_text" v-if="radio == 'alipay'">
                    请用支付宝扫码进行支付
                </div>
                <div class="on_text" v-if="radio == 'wechat'">
                    请用微信扫码进行支付
                </div> -->
                <!-- <div class="on_text" v-if="radio == 'alipay'">
                   功能暂未开放~
                </div>
                <div class="on_text" v-if="radio == 'wechat'">
                    功能暂未开放~
                </div> -->
            </div>
            <div class="confirm" @click="result" style="width: 300px;margin: 30px auto;">
					确认支付完成
				</div>
        </div>
        <bottom></bottom>
        <!-- <el-dialog :visible.sync="buy_code" width="80rem" @close="buy_close">
      <div class="buy_box dis_f_c_c">
        <div id="qrcode" ref="qrcode" class="img1 dis_f_c_c"></div>
        <img src="static/image/store/pay2.png" class="img2" alt="" />
      </div>
    </el-dialog> -->
    </div>
</template>
<script>
import { orderDetail, prepay, payScanpay } from "@/api/index.js";
import { countDown, timestampToTime } from "@/util/util.js";
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
export default {
    data() {
        return {
            id: "",
            radio: "alipay",
            info: {},
            createTime: "",
            payImg: ""
        };
    },
    created() {
        this.id = this.$route.query.id;
        this.detail();
        console.log(localStorage.getItem("userInfo"));
    },
    mounted() {},
    methods: {
        detail() {
            orderDetail({ id: this.id }, header).then(res => {
                if (res.code !== 1) {
                    return this.$message.error(res.msg);
                }
                this.info = res.data;
                console.log(this.info);
                console.log(timestampToTime(this.info.createtime));
                this.createTime = timestampToTime(this.info.createtime*1000);
                this.confirm();
            });
        },
        confirm() {
            //二维码支付
            payScanpay({
                order_sn: this.info.order_sn,
                payment: this.radio
            }).then(res => {
                if (res.code == 1) {
                    this.payImg = res.data.src;
                }
                console.log(res);
            });
        },
        handlePay(){
         payScanpay({
                order_sn: this.info.order_sn,
                payment: this.radio
            }).then(res => {
                if (res.code == 1) {
                    this.payImg = res.data.src;
                }
                console.log(res);
            });
        },
        result(){
            this.$router.push({path:'/mine'})
        }
    },
    components: {
        top,
        bottom
    }
};
</script>
<style lang="less" scoped>
.btn{
    margin-bottom: 20px;
}
.goods-box {
    margin: 20px 0;
    .goods-left {
        img {
            width: 204px;
            height: 179px;
            margin-right: 10px;
        }
        .goods-info {
            height: 170px;
        }
    }
}
.pay-box {
    margin-bottom: 10px;
    .title {
        height: 70px;
        line-height: 70px;
        color: #0097fe;
        font-size: 26px;
        display: flex;
        align-items: center;
        .title-line {
            width: 5px;
            height: 21px;
            background: #ff6701;
            border-radius: 3px;
            margin-right: 10px;
        }
    }
    .pay-type {
        display: flex;
        align-items: center;
        height: 80px;
        border: solid 1px #999;
        border-left: none;
        border-right: none;
    }
}
.onPay {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .erweima {
        width: 200px;
        height: 46px;
        font-size: 26px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        // color: #0097fe;
        line-height: 39px;
    }
    .zhifu {
        width: 142px;
        height: 137px;
        border: 1px solid #979797;
        display: flex;
        justify-content: center;
        align-items: center;
        .el-image {
            width: 123px;
            height: 123px;
        }
    }
    .on_text {
        width: 132px;
        height: 12px;
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/pay.vue